import Vue from 'vue';
import App from './views/main/index.vue';
import router from './router/index';
import store from './store/index';
import 'default-passive-events';

// 套件引入
import VueFeather from 'vue-feather';
import { Icon } from '@iconify/vue2';
import preview from 'vue-photo-preview';
import format from 'vue-text-format';
import 'vue-photo-preview/dist/skin.css';
import './plugins/element.js';
import './assets/theme/index.css';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import { VueMasonryPlugin } from 'vue-masonry';

// 自定義樣式
import './assets/scss/core.scss';

Vue.config.productionTip = false;
Vue.use(VueFeather);
Vue.component('iconify-icon', Icon);
Vue.use(preview);
Vue.use(format);
Vue.use(VueAwesomeSwiper);
Vue.use(VueMasonryPlugin);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
